import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

const TechnicalDetails = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
`;

const Detail = ({ entry, onHide }) => {
  return (
    <Modal show={Boolean(entry)} onHide={onHide} size={"lg"}>
      <Modal.Header closeButton>
        <Modal.Title>{entry?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{entry?.description}</div>
        <TechnicalDetails>{entry?.technical_details}</TechnicalDetails>
      </Modal.Body>
    </Modal>
  );
};
export default Detail;
